<div class="user-session" [class.user-session-open]="menuAbierto">
  <button type="button" class="user-session-trigger" (click)="toggleMenu($event)" aria-label="Menu de usuario">
    <span class="user-session-avatar">
      <img *ngIf="avatarUrl; else initialsTpl" [src]="avatarUrl" alt="Avatar del usuario" />
      <ng-template #initialsTpl>{{ iniciales }}</ng-template>
    </span>

    <span class="user-session-copy">
      <strong>{{ nombreVisible }}</strong>
      <small>{{ rolLabel }}</small>
    </span>

    <span class="user-session-chevron" aria-hidden="true">&#9662;</span>
  </button>

  <input
    #avatarInput
    class="user-session-file-input"
    type="file"
    accept="image/*"
    (change)="onAvatarSeleccionado($event)"
  />

  <div class="user-session-menu" *ngIf="menuAbierto">
    <div class="user-session-menu-head">
      <strong>{{ nombreVisible }}</strong>
      <small>{{ correoVisible || rolLabel }}</small>
    </div>

    <button type="button" class="user-session-action" (click)="irAMiPerfil()">Mi perfil</button>
    <button type="button" class="user-session-action" (click)="solicitarCambioAvatar()">Cambiar avatar</button>
    <button type="button" class="user-session-action" *ngIf="avatarUrl" (click)="quitarAvatar()">Quitar avatar</button>
    <button type="button" class="user-session-action user-session-action-danger" (click)="cerrarSesionMock()">
      Cerrar sesion
    </button>
  </div>
</div>
